import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppLovac from "./AppLovac";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.css";
import Clanovi from "./components/clanovi";
import "bootstrap/dist/css/bootstrap.min.css";

//ReactDOM.render(<Clanovi />, document.getElementById("root1"));
ReactDOM.render(<AppLovac />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
